// Globals
window._ = require('lodash');
window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');

// Imports
import 'bootstrap';
import axios from 'axios';
import store from './store';
import NProgress from 'nprogress';
import router from './routes.js';

// Configure NProgress
NProgress.configure({ showSpinner: false });

// Confgure Axios
axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  'Content-Type':'application/json',
  'Accept':'application/json',
};

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// Add loading screens
axios.interceptors.request.use(config => {
  store.commit('loading/increment');
  NProgress.start();
  return config;
},  (err) => {
  store.commit('loading/decrement');
  NProgress.done();
  return Promise.reject(err);
});

axios.interceptors.response.use(response => {
  store.commit('loading/decrement');
  NProgress.done();
  return response;
},(err) => {
  store.commit('loading/decrement');

  if (err.status === 401) {
    store.dispatch('user/setLoggedOut');

    router.push('/login');

    store.dispatch('notifications/setSuccess', 'Your session has expired. Please log in again. (Error: 1)');
  }

  NProgress.done();
  return Promise.reject(err);
});
